import { Div } from '@codesuma/baseline'
import style from './index.module.css'

// Slides — the strip the wizard's steps live in. Holds one step at a time and
// slides the swap sideways: forward brings the next step in from the right,
// back from the left. Only this strip moves; the header above and the buttons
// below stay put. Ported from emrouz's wizard.

const DURATION = 280

type Direction = 'forward' | 'back' | 'none'
type Slide = ReturnType<typeof Div>

export const Slides = () => {
    const base = Div()
    base.addClass(style.stage)

    let current: Slide | null = null

    const show = (next: Slide, direction: Direction) => {
        const previous = current
        current = next

        next.addClass(style.slide)
        if (direction !== 'none') next.addClass(direction === 'back' ? style.fromLeft : style.fromRight)
        base.append(next)

        // Force a layout pass so the off-screen start lands on its own frame.
        // Without it the browser batches both class changes and the step just
        // appears at rest.
        void next.el.offsetWidth
        next.removeClass(style.fromLeft, style.fromRight)

        if (!previous) return
        // Re-entering the page: swap outright rather than animate a step the
        // user never saw.
        if (direction === 'none') return previous.remove()
        previous.addClass(direction === 'back' ? style.toRight : style.toLeft)
        setTimeout(() => previous.remove(), DURATION)
    }

    return Object.assign(base, { show })
}
